import { Image } from '@cian/ui-kit/image';
import { IconPlaceholderImage16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './CardGalleryMainMedia.css';
import { IFavoriteEntityMedia } from '../../../../../types/results';
import { CardGallerySliderLoadable } from '../CardGallerySlider';

export interface ICardGalleryMainMediaProps {
  media: IFavoriteEntityMedia[];
  alt: string;
  url: string;
}

export const CardGalleryMainMedia: React.FC<ICardGalleryMainMediaProps> = ({ media, alt, url }) => {
  const [mainMedia] = media;
  const hasSlider = media.length > 1;
  const isSliderReady = useIsSliderReady(hasSlider);

  if (!mainMedia) {
    return (
      <div className={styles['empty']} data-testid="CardGalleryEmpty">
        <IconPlaceholderImage16 color="icon-secondary-default" />
      </div>
    );
  }

  if (hasSlider && isSliderReady) {
    return <CardGallerySliderLoadable media={media} alt={alt} url={url} />;
  }

  return <Image src={mainMedia.fullUrl || mainMedia.previewUrl} alt={alt} objectFit="cover" borderRadius={0} />;
};

function useIsSliderReady(isEnabled: boolean): boolean {
  const [isReady, setIsReady] = React.useState(false);

  React.useEffect(() => {
    if (!isEnabled) {
      return undefined;
    }

    let isActual = true;

    CardGallerySliderLoadable.load()
      .then(() => {
        if (isActual) {
          setIsReady(true);
        }
      })
      .catch(() => undefined);

    return () => {
      isActual = false;
    };
  }, [isEnabled]);

  return isReady;
}
